
import HeroTextContent from './hero/HeroTextContent';
import HeroContentCard from './hero/HeroContentCard';

const HeroSection = () => {
  return (
    <section className="bg-hero-gradient pt-28 pb-20">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
          {/* Text Content - Now with flex column layout */}
          <div className="flex flex-col justify-between h-full">
            <HeroTextContent />
          </div>

          {/* Illustration */}
          <HeroContentCard />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
